<template>
  <v-container>
    <v-row>
      <v-col
        cols="12"
        sm="12"
        md="12"
        lg="8"
        class="offset-lg-2"
      >
        <v-row>
          <v-col>
              <v-list-item class="pa-0">
                <v-list-item-avatar>
                  <v-img :src="integ.logo" :alt="integ.name"></v-img>
                </v-list-item-avatar>
                 <v-list-item-content>
                  <v-list-item-title >{{ integ.name }} Integration</v-list-item-title>
                </v-list-item-content>

              </v-list-item>
              <v-list-item-content>
                <v-text-field
                  v-model="config.name"
                  label="Name"
                  placeholder="Configuration's name"
                  required
                  @input="handleChange"
                />
              </v-list-item-content>
              <v-list-item-content>
                <v-form>
                  <template
                      v-for="(el, index) in integ.config"
                      v-key="index"
                    >
                      <v-col :key="index" class="pa-0">
                        {{ integ.name + '.' + el.name }}
                        <span
                          v-if="el.required"
                          style="color: red"
                        >*</span>
                        <v-text-field
                          v-if="config.values"
                          v-model="config.values[el.name]"
                          :required="el.required || false"
                          :disabled="el.readonly"
                          :placeholder="el.placeholder"
                          :type="el.to_hide ? el.type ? el.type : 'password' : 'text'"
                          :append-icon="el.to_hide ? el.type && el.type === 'text' ? 'mdi-eye-off' : 'mdi-eye' : ''"
                          @input="handleChange"
                          @click:append="handleTogglePasswordView(el)"
                        />
                      </v-col>
                  </template>
                </v-form>
              </v-list-item-content>

            <div
              v-if="!!identifier"
              class="text-center d-flex-inline"
            >
              <v-btn
                text
                color="red"
                outlined
                :disabled="loading.config"
                @click="destroy"
              >
                <v-icon
                  left
                  small
                >
                  mdi-delete-outline
                </v-icon>
                Delete
              </v-btn>
              <v-btn
                :disabled="!isReadyForUpdate || loading.config"
                class="ml-2"
                color="primary"
                @click="update"
              >
                <v-icon
                  small
                  left
                >
                  mdi-content-save-outline
                </v-icon>
                Update
              </v-btn>
              <singer-discovery
                v-if="integ.is_singerio"
                :disabled="isReadyForUpdate"
                :config="config.id"
              />
              <singer-execution
                v-if="integ.is_singerio"
                :disabled="isReadyForUpdate"
                :config="config.id"
              />
            </div>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
  import SingerDiscovery from './SingerDiscovery.vue'
  import SingerExecution from "./SingerExecution";
  import IntegrationService from './services/IntegrationService'
  export default {
    components: { SingerDiscovery, SingerExecution},
    props: {
      identifier: {
        required: false,
        type: String,
        default: () => { return null },
      },
      value: {
        type: Object,
        required: false,
        default: () => { return null },
      },
      integration: {
        type: Object,
        required: false,
        default: () => {
          return null
        },
      },
      project: {
        type: Object,
        required: false,
        default: () => {
          return {
            name: null,
          }
        },
      },
    },
    data () {
      return {
        oldConfig: {},
        config: {},
        loading: {
          config: false,
        },
        singerDiscovery: {
          tables: [],
          streams: [],
        },
      }
    },
    computed: {

      integ () {
        let integ = {
          name: '',
          logo: '',
          is_singerio: false,
        }
        if (this.integration != null) {
          integ = _.cloneDeep(this.integration)
        } else if (this.config.integration != null) {
          integ = _.cloneDeep(this.config.integration)
        }
        return integ
      },
      isReadyForUpdate () {
        return !_.isEqual(this.config, this.oldConfig)
      },
    },
    mounted () {
      if (this.value == null) {
        // we are in "GET/EDIT/DELETE" mode
        this.get()
      } else {
        // we are in "CREATE" mode
        this.prepareForCreate()
      }
    },
    methods: {
      handleTogglePasswordView (el) {
        el.type = el.type === 'text' ? 'password' : 'text'
        this.$forceUpdate()
      },
      prepareForCreate () {
        let self = this
        self.config.integration = self.integration
        self.config.values = {}
        _.map(self.config.integration.config, c => {
          self.config.values[c.name] = c.value || ''
        })
        this.$forceUpdate()
        this.handleChange()
      },
      get () {
        let self = this
        self.loading.config = true
        IntegrationService.getConfig(self, self.identifier).then(res => {
          if (res) {
            res.data.integration.config = res.data.integration.fields
            self.config = res.data
            self.oldConfig = _.cloneDeep(res.data)
          }
        }).finally(() => {
          self.loading.config = false
        })
      },
      handleChange () {
        let conf = _.cloneDeep(this.config)
        conf.integration = conf.integration.id
        this.$emit('input', conf)
      },
      destroy () {
        let self = this
        this.$store.commit('confirm', {
          message: 'Do you really want to delete this configuration ?',
          title: 'Warning',
          color: 'warning',
          onCancel: () => {},
          onConfirm: () => {
            IntegrationService.deleteConf(this.config.id, this).then((r) => {
              self.$store.commit('push', {
                msg: `Deleted successfully`,
                color: 'success',
              })
              self.$emit('delete')
            })
          },
        })
      },
      update () {
        let self = this
        let conf = _.cloneDeep(this.config)
        conf.integration = self.integ.id
        self.loading.config = true
        IntegrationService.updateConfiguration(conf, self).then(res => {
          self.$emit('update', res.data)
          res.data.integration.config = res.data.integration.fields
          self.config = res.data
          self.oldConfig = _.cloneDeep(res.data)
          self.$store.commit('push', {
            msg: `Updated successfully`,
            color: 'success',
          })
        }).finally(() => {
          self.loading.config = false
        })
      },
    },
  }
</script>
